import React from 'react';
import { GripVertical, X } from 'lucide-react';
import { useDashboardStore } from '../../store/dashboardStore';
import { Button } from '@/components/Button';

interface WidgetWrapperProps {
  id: string; // The instance ID of the widget
  tabId: string;
  title?: string;
  children: React.ReactNode;
}

/**
 * Card frame for a dashboard widget. The whole header is the drag handle; the
 * grip and remove controls appear on hover / focus so resting cards stay quiet.
 */
export function WidgetWrapper({ id, tabId, title, children }: WidgetWrapperProps) {
  const removeWidget = useDashboardStore((state) => state.removeWidget);

  return (
    <section className="group flex h-full w-full flex-col overflow-hidden rounded-lg border border-border bg-card transition-colors hover:border-border-strong">
      <header className="widget-drag-handle flex h-11 shrink-0 cursor-grab items-center gap-1.5 border-b border-border pl-2 pr-1.5 active:cursor-grabbing">
        <GripVertical className="size-4 shrink-0 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-hidden />
        <h2 className="min-w-0 flex-1 truncate font-display text-card-title text-foreground">{title || 'Widget'}</h2>
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={`Remove ${title || 'widget'}`}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => { e.stopPropagation(); removeWidget(tabId, id); }}
          className="size-7 opacity-0 hover:text-destructive focus-visible:opacity-100 group-hover:opacity-100"
        >
          <X />
        </Button>
      </header>
      <div className="relative min-h-0 flex-1 overflow-hidden">{children}</div>
    </section>
  );
}
